import { hash } from '@ember/helper';
import type Owner from '@ember/owner';
import Component from '@glimmer/component';
import Modifier, { type PositionalArgs } from 'ember-modifier';
import fuiProgress from 'wise-fui-modules/modifiers/fui-progress';

interface Signature {
  Args: {
    progress: number;
  };
  Blocks: {
    default: [];
  };
}

export default class Progress extends Component<Signature> {
  declare progress: number;

  constructor(owner: Owner, args: Signature['Args']) {
    super(owner, args);
    this.progress = this.args.progress;
  }

  updateProgress = ProgressModifier;

  <template>
    <div
      class='ui progress teal'
      {{fuiProgress (hash percent=this.progress)}}
      {{this.updateProgress @progress}}
    >
      <div class='bar'></div>
      <div class='label'>
        {{yield}}
      </div>
    </div>
  </template>
}

interface ProgressSignature {
  Args: {
    Positional: [number];
  };
}

interface HTMLProgressElement extends JQuery {
  progress: (command: 'set percent', percent: number) => void;
}

class ProgressModifier extends Modifier<ProgressSignature> {
  #isUpdated = false;

  modify(
    progressBar: HTMLElement,
    [progress]: PositionalArgs<ProgressSignature>
  ) {
    if (this.#isUpdated) {
      ($(progressBar) as HTMLProgressElement).progress('set percent', progress);
    }
    this.#isUpdated = true;
  }
}
